module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 2
    }
  }, [(_vm.isGoogle2faEnabled) ? _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.google2faEnabledWarning')))]), _vm._v(" "), _c('el-button', {
    staticClass: "small",
    on: {
      "click": function($event) {
        return _vm.closeModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.close')))])], 1) : _c('el-col', {
    attrs: {
      "xs": 24,
      "sm": 24
    }
  }, [_c('h3', {
    staticClass: "wizardTitle"
  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.title')))]), _vm._v(" "), _c('div', [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.$t('static.smsTwoFactorVerification.enableWarningMessage'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "el-form-item margin-b-0"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.verifyMobileNUmber')))]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    staticClass: "margin-b-10",
    attrs: {
      "placeholder": _vm.$t('static.smsTwoFactorVerification.enterMobileNUmber')
    },
    model: {
      value: (_vm.mobileNumber),
      callback: function($$v) {
        _vm.mobileNumber = $$v
      },
      expression: "mobileNumber"
    }
  }, [_c('template', {
    slot: "prepend"
  }, [_vm._v("+47")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-mobile-phone",
      "disabled": _vm.twoFactorTimerCount > 0,
      "loading": _vm.sendLoading
    },
    on: {
      "click": _vm.sendVerificationToken
    },
    slot: "append"
  }, [_vm._v("\n                    " + _vm._s(_vm.verificationSent ? _vm.$t('static.smsTwoFactorVerification.resendCode') : _vm.$t('static.smsTwoFactorVerification.sendCode')) + "\n                    "), (_vm.twoFactorTimerCount > 0) ? _c('span', [_vm._v("(" + _vm._s(_vm.twoFactorTimerCount || '') + ")")]) : _vm._e()])], 2)], 1)]), _vm._v(" "), (_vm.verificationSent) ? _c('div', {
    staticClass: "el-form-item"
  }, [_c('label', {
    staticClass: "el-form-item__label"
  }, [_vm._v(_vm._s(_vm.$t('static.smsTwoFactorVerification.codeVerification')))]), _vm._v(" "), _c('div', {
    staticClass: "el-input"
  }, [_c('el-input', {
    staticClass: "margin-b-10",
    attrs: {
      "placeholder": _vm.$t('static.smsTwoFactorVerification.enterToken')
    },
    model: {
      value: (_vm.twoFactorAuthToken),
      callback: function($$v) {
        _vm.twoFactorAuthToken = $$v
      },
      expression: "twoFactorAuthToken"
    }
  }, [_c('el-button', {
    staticStyle: {
      "box-shadow": "none"
    },
    attrs: {
      "slot": "append",
      "icon": "el-icon-check",
      "loading": _vm.verifyLoading
    },
    on: {
      "click": _vm.verifyToken
    },
    slot: "append"
  }, [_vm._v("\n                    " + _vm._s(_vm.$t('static.smsTwoFactorVerification.verifyCode')) + "\n                  ")])], 1)], 1)]) : _vm._e()])])])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b4080a9a","hasScoped":false}!./src/app/components/smsTwoFactorAuthSetup/smsTwoFactorAuthSetup.html
// module id = 3107
// module chunks = 1